import React from 'react'
import { NodataSvg } from '../../assets/svg/nodataSvg'

interface Props {
    /** translated "No data" label; English fallback used when omitted */
    label?: string
}

const Nodata = ({ label = 'No data' }: Props) => {
    return (
        <div className="fr-my-3 fr-text-center">
            <div className='fr-inline-block'>
                <NodataSvg />
            </div>
            <div className="ant-empty-description fr-text-slate-500">
                {label}
            </div>
        </div>
    )
}

export default Nodata